export default __webpack_public_path__ + "static/grid-breakpoints-light-4777282cae0bbe0a06e0df6f8d67224e2d328d76f820f1e3676a112515e9f8a3.png";